<template>
<div class="mgm mgmindex">
    <div class="mgm-bg">
        <img style="visibility: hidden;position:absolute;" :src="ilogSrc" />
        <div class="m-b-1"></div>
        <div class="m-b-2">
            <div class="register-box">
                <div class="enter">
                    <div class="phone">
                        <input placeholder="请输入手机号" maxLength=11 v-model="phone" type="tel" />
                    </div>
                    <div class="code">
                        <input maxLength=6 placeholder="请输入验证码" v-model="code" type="tel" />
                        <!-- ilogCode -->
                        <button @click="getCode" data-ilog="14.1504.pP0">{{codeMsg}}</button>
                    </div>
                    <button class="apply" @click="shareHandle" data-ilog="14.1504.fH3"></button>
                    <!-- <div class="agreement">
                        <p>
                            《<span  @click="argumentHandle">用户协议</span>》
                        </p>
                    </div> -->
                </div>
            </div>
        </div>
        <div class="m-b-3">
            <div class="event-header"></div>
            <div class="event-text">
                <p>1. <b>活动时间：</b></p>
                <p>2017年即日起-2017年12月21日 23:59分</p>
                <p>2. <b>奖品：</b>58元点点免息券。</p>
                <p>3. <b>获奖条件：</b>新用户下载登录点点APP，完成申请并获得授信额度即可获得奖品。</p>
                <p>4. <b>奖品使用：</b>点点免息券在提现时可抵用同等金额利息，具体使用方法详见 我的优惠券-免息券使用说明。</p>
                <p>5. <b>奖品效期：</b>30天，包括领券日当天。超过有效期未使用免息券则自动失效。</p>
                <p>6. 本次活动最终解释权归深圳众联商务所有。</p>
            </div>
        </div>
        <div class="m-b-4"></div>
        <div class="m-b-5"></div>
    </div>
    <toast v-show="isToast">
        <slot>{{toastMsg}}</slot>
    </toast>
    <loading v-show="isLoading"></loading>
</div>
</template>
    <style lang="sass">
        @import '../assets/styles/all.scss';
        .mgmindex{
            background: #7e6afa;
        }
        .mgm{
            max-width: 640px;
        }
        .mgm-bg-main{
            .agreement{
                margin-top: r(15);
                color: #1560f5;
                p{
                    span{
                        text-decoration: underline;
                        padding-bottom: 1px;
                    }
                }
            }
        }
        .mgm-bg{
            position: relative;
            >div{
                width: 100%;
            }
            .m-b-1{
                height: r(240);
                background: url(../assets/images/mgm-bg-1.jpg);
                background-size:100% 100%;
            }
            .m-b-2{
                height: r(218);
                background: url(../assets/images/mgm-bg-2.jpg);
                background-size:100% 100%;
                .register-box{
                    padding-top: r(0);
                    .enter{
                        text-align: center;
                        input{
                            width: r(288);
                            height: r(55);
                            margin-bottom: r(15);
                            font-size: r(15);
                            box-sizing: border-box;
                            padding-left: r(50);
                            line-height: normal;
                        }
                        .phone{
                            width: 78%;
                            margin: 0 auto;
                        }
                        .code{
                            width: 78%;
                            margin: 0 auto;
                            position: relative;
                            button{
                                position: absolute;
                                right: r(0);
                                top:r(0);
                                color: #5144f9;
                                height: r(55);
                                width: r(115);
                                line-height: r(55);
                                text-align: center;
                                // font-weight: bold;
                            }
                        }
                        .apply{
                            width: r(330);
                            height: r(64);
                        }
                    }
                }
            }
            .m-b-3{
                width: 90%;
                margin: 0 auto;
                border-radius: r(10);
                position: relative;
                overflow: hidden;
                // background: url(../assets/images/mgm-bg-3.jpg);
                // background-size:100% 100%;

                /* Permalink - use to edit and share this gradient: http://colorzilla.com/gradient-editor/#7042f5+0,4058f3+100 */
                background: #7042f5; /* Old browsers */
                background: -moz-linear-gradient(top, #7042f5 0%, #4058f3 100%); /* FF3.6-15 */
                background: -webkit-linear-gradient(top, #7042f5 0%,#4058f3 100%); /* Chrome10-25,Safari5.1-6 */
                background: linear-gradient(to bottom, #7042f5 0%,#4058f3 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
                filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#7042f5', endColorstr='#4058f3',GradientType=0 ); /* IE6-9 */

                .event-header{
                    width: r(157);
                    height: r(25);
                    position: relative;
                    top: r(20);
                    left: 50%;
                    -webkit-transform:translateX(-50%);
                    background: url("../assets/images/i-t-bg.jpg") no-repeat;
                    background-size: 100% 100%;
                }

                .event-text{
                    width: 90%;
                    margin: 0 auto;
                    box-sizing: border-box;
                    padding:r(35) r(10) r(18) r(10);
                    p{
                        color: #ffffff;
                        font-size: r(13);
                        padding-bottom: r(10);
                        text-align:justify;
                        text-justify:inter-ideograph;
                    }
                }
            }
            .m-b-4{
                height: r(166);
                background: url(../assets/images/mgm-bg-4.jpg);
                background-size:100% 100%;
            }
            .m-b-5{
                height: r(229);
                background: url(../assets/images/mgm-bg-5.jpg);
                background-size:100% 100%;
            }

        }
    </style>
<script>
import {
    api,
    apiRsa
} from '../api/axios';
import Loading from '../components/loading';
import Toast from '../components/toast';
import config from '../config';
import storage from '../utils/storage';
import {
    getNow,
    randomString
} from '../utils/tool.js'
import {
    wxAuth
} from '../utils/wxauth'
import {
    share
} from '../utils/wxshare'
// import Rsa from '../utils/rsa';


export default {
    data() {
        return {
            ilogSrc: '',
            helplist: [],
            isLoading: false,
            isToast: false,
            isChecked: false,
            code: '',
            toastMsg: '',
            codeMsg: '获取验证码',
            hrefPath: '',
            phone: '',
            platform: '',
            deviceType: '',
            latitude: '',
            longitude: '',
            reg: {
                name: /^([\u4e00-\u9fa5 ]{0,20})$/,
                number: /(^\d{18}$)|(^\d{17}(\d|X|x)$)/,
                card: /^\d{4,19}$/,
                phone: /^1\d{10}$/,
                code: /^\d{4,6}$/
            }
        }
    },
    components: {
        Loading,
        Toast
    },
    watch: {
        isToast(n, o) {
            //console.log(n,o);
            if (n == true) {
                setTimeout(() => {
                    this.isToast = false;
                }, 3000)
            }
        }
    },
    beforeRouteEnter(to, from, next) {
        document.title = '点点有钱'
        next()
    },
    created(){
        var urlParam = this.$route.query
        let inviter = urlParam.inviter || ''
        window.location.href='https://fin-app.zhongan.com/sh/event/diandian-mark/#/mgmsharedraw?inviter=' + inviter + '&inviteway=wechat';
    },
    mounted() {

        // window.location.href='https://fin-app.zhongan.com/sh/event/diandian-mark/#/mgmsharedraw'

        this.hUrl = '';
        switch (config.ENV) {
            case '-test':
                this.hUrl = 'https://one-test.zhongan.com/fcp/event/diandian/#/download?campaignNo=HD20171108MGM'
                break
            case '-uat':
                this.hUrl = 'https://one-uat.zhongan.com/fcp/event/diandian/#/download?campaignNo=HD20171108MGM'
                break
            case '':
                this.hUrl = 'https://fin-app.zhongan.com/sh/event/diandian-mark/#/download?campaignNo=HD20171108MGM'
                break
        }

        this.geolocation();
        this.userAgent();

        var u = navigator.userAgent
        //微信
        if (u.match(/MicroMessenger/i) == 'MicroMessenger') {
            // wxAuth()
            share(this)
        }

        // console.log(Rsa('18616227901'),'---rsa');

    },
    methods: {
        getCode() {
            if (this.codeMsg == '获取验证码') {
                if (this.reg.phone.test(this.phone)) {
                    //倒计时
                    var s = 60;
                    var timer = null;
                    this.codeMsg = (--s) + 's';
                    timer = setInterval(() => {
                        this.codeMsg = (--s) + 's';
                        if (s == 0) {
                            s = 60;
                            clearInterval(timer);
                            this.codeMsg = '获取验证码';
                        }
                    }, 1000)

                    this.isLoading = true;

                    api({
                        id: 'userAPI.sendOTPForH5V2',
                        param: {
                            "partnerNo": "NYDDXJD",
                            "mobile": this.phone,
                            "otpType": 1,
                            "apiVersion": "1.0.0",
                            "reqNo": randomString(20),
                            "reqDate": getNow()
                        }
                    }).then((res) => {
                        if (res.status == 200) {
                            var data = res.data
                            // console.log(data);
                            this.isLoading = false;
                            if (data.code == 1) {
                                //成功
                            } else {
                                this.toastMsg = data.message;
                                this.isToast = true;
                            }
                        } else {
                            this.toastMsg = '请求失败';
                            this.isToast = true;
                            this.isLoading = false;
                        }
                    }).catch((error) => {
                        this.toastMsg = '请求失败';
                        this.isToast = true;
                        this.isLoading = false;
                    })

                } else {
                    this.toastMsg = '请输入正确的手机号';
                    this.isToast = true;
                }
            }
        },
        userAgent() {
            var u = window.navigator.userAgent;
            console.log(u);
            //操作系统
            if (u.indexOf('Intel Mac OS') > -1) {
                this.platform = 'MAC';
            } else if (u.indexOf('iPhone') > -1) {
                this.platform = 'ios'
            } else if (u.indexOf('iPad') > -1) {
                this.platform = 'IPad'
            } else if (u.indexOf('Android') > -1) {
                this.platform = 'android'
            } else {
                this.platform = 'Windows'
            }
            //设备类型  Pad、mobile、PC
            if (u.indexOf('Intel Mac OS') > -1 || u.indexOf('Windows') > -1) {
                this.deviceType = 'PC';
            } else if (u.indexOf('iPhone') > -1 || u.indexOf('Android') > -1) {
                this.deviceType = 'mobile';
            } else if (u.indexOf('iPad') > -1) {
                this.deviceType = 'Pad';
            }
            console.log('操作系统:', this.platform);
            console.log('设备类型:', this.deviceType);
        },
        geolocation() {
            //判断浏览器是否支持geolocation
            var _this = this;
            navigator.geolocation.getCurrentPosition( // 该函数有如下三个参数
                function(pos) { // 如果成果则执行该回调函数
                    _this.latitude = pos.coords.latitude
                    _this.longitude = pos.coords.longitude
                    console.log(
                        '  经度：' + pos.coords.latitude +
                        '  纬度：' + pos.coords.longitude +
                        '  高度：' + pos.coords.altitude +
                        '  精确度(经纬)：' + pos.coords.accuracy +
                        '  精确度(高度)：' + pos.coords.altitudeAccuracy +
                        '  速度：' + pos.coords.speed
                    );
                },
                function(err) { // 如果失败则执行该回调函数
                    console.log(err.message);
                }, { // 附带参数
                    enableHighAccuracy: false, // 提高精度(耗费资源)
                    timeout: 3000, // 超过timeout则调用失败的回调函数
                    maximumAge: 1000 // 获取到的地理信息的有效期，超过有效期则重新获取一次位置信息
                }
            );

        },
        shareHandle() {
            if (!this.reg.phone.test(this.phone)) {
                this.isToast = true;
                this.toastMsg = '请输入正确的手机号'
                return
            }

            if (!this.reg.code.test(this.code)) {
                this.isToast = true;
                this.toastMsg = '请输入正确的验证码'
                return
            }

            var urlParam = this.$route.query
            // console.log(this.$route.query, 'urlParam');
            var nowInviter = urlParam.inviter || '';
            var nowInviteWay = urlParam.inviteway || '';
            // var campaignNo=urlParam.campaignNo || '';
            // if(campaignNo='HD20171108MGM'){
            //     storage.set({'ilogDownLoad':'14.1505.jR9'})
            // }
            // storage.set({'campaignNo':campaignNo})
            //请求接口
            this.isLoading = true;

            var nowPlatform = this.latitude + ',' + this.longitude;
            nowPlatform = nowPlatform ? nowPlatform : '';

            //注册
            api({
                id: 'userAPI.register',
                param: {
                    "partnerNo": "NYDDXJD",
                    "tel": this.phone,
                    "loginName": this.phone,
                    "verifyCode": this.code,
                    "apiVersion": "1.0.0",
                    "reqNo": randomString(20),
                    "reqDate": getNow(),
                    'inviter': nowInviter,
                    'inviteWay': nowInviteWay,
                    'registerPlatform': 'h5',
                    'campaignNo': 'HD20171108MGM',
                    'geoLocation': nowPlatform,
                    'platform': this.platform,
                    'deviceType': this.deviceType
                }
            }).then((res) => {
                // console.log(res,'r');
                if (res.status == 200) {
                    var data = res.data;
                    this.isLoading = false;
                    if (data.code == "0106") {
                        //用户已存在
                        window.location.href = this.hUrl;
                        return
                    }
                    if (data.code == 1) {
                        this.isToast = true;
                        this.toastMsg = '注册成功，请耐心等待页面跳转';
                        setTimeout(() => {
                            window.location.href = this.hUrl;
                        }, 1000)
                    } else {
                        this.toastMsg = data.message;
                        this.isToast = true;
                    }
                } else {
                    this.toastMsg = '请求失败';
                    this.isToast = true;
                }
            }).catch(() => {
                this.isLoading = false
                this.toastMsg = '请求失败';
                this.isToast = true;
            })
        },
        checkMobileregister(fn) {
            //校验用户是否已经注册
            var urlParam = this.$route.query
            api({
                id: 'userAPI.checkMobileregister',
                param: {
                    "partnerNo": "NYDDXJD",
                    "mobile": this.phone,
                    "apiVersion": "1.0.0",
                    "reqNo": randomString(20),
                    "reqDate": getNow()
                }
            }).then((res) => {
                if (res.status == 200) {
                    var data = res.data
                    console.log(data, 'ck');
                    this.isLoading = false
                    if (data.code == 1) {
                        //success
                        console.log(data.data.isRegister);
                        fn.call(this)
                    } else if (data.code == 1401) {
                        //已经注册
                        // alert('您已注册，点击确认进入APP')
                        window.location.href = this.hUrl
                    } else {
                        this.toastMsg = data.message;
                        this.isToast = true;
                    }
                }
            }).catch((error) => {
                this.isLoading = false
                this.toastMsg = '请求失败';
                this.isToast = true;
            })

        }
    }
}
</script>



// WEBPACK FOOTER //
// mgmindex.vue?8235abfc